import React, { useState } from "react";
import moment from "moment";

const AircraftFuelLogDialogValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({

    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (!record) return; 

  const calculatedUpliftFuelUsg = ((record.upliftedKg||0) / (record.kgToUsg||0)).round(5);

  if (record.fuelLogMode === 'DELAYED') {
    if (record.openingFuelKg !== null) {
      if (record.openingFuelKg === null || isNaN(parseFloat(record.openingFuelKg))) {
        error = true;
        errorMessage = "The 'Opening Fuel' weight is invalid, please enter a valid number";
        field = "openingFuelKg";
      } else if (record.openingFuelKg < 0) {
        error = true;
        errorMessage = "The 'Opening Fuel' weight may not be less than zero";
        field = "openingFuelKg";
      }
      if (record.blockFuelKg > 0) {
        if (record.openingFuelKg > record.blockFuelKg) {
          error = true;
          errorMessage = "The 'Opening Fuel' weight cannot exceed the block fuel weight";
          field = "openingFuelKg";
        } else if (record.openingFuelKg === record.blockFuelKg && record.upliftedKg) {
          error = true;
          errorMessage = "The 'Opening Fuel' weight cannot be equal to the block fuel weight if fuel was uplifted";
          field = "openingFuelKg";
        }
      }
      if (record.openingFuelValue === null) {
        if (record.openingFuelValue === null || isNaN(parseFloat(record.openingFuelValue))) {
          error = true;
          errorMessage = "The 'Opening Fuel' value is invalid, please enter a valid number";
          field = "openingFuelValue";
        } else if (record.openingFuelValue < 0) {
          error = true;
          errorMessage = "The 'Opening Fuel' value may not be less than zero";
          field = "openingFuelValue";
        } else if (record.openingFuelKg > 0 && record.openingFuelValue === 0 ) {
          error = true;
          errorMessage = "The 'Opening Fuel' value may not be zero";
          field = "openingFuelValue";
        }
      }
    }
    if (record.upliftFuelUsg > 0 && (record.upliftFuelUsg < calculatedUpliftFuelUsg * 0.9 || record.upliftFuelUsg > calculatedUpliftFuelUsg * 1.1)) {
      error = true;
      errorMessage = "The 'Uplifted Fuel' in USG is outside the 10% tolerance compared to uplifted fuel weight";
      field = "upliftFuelUsg";
    }
    if (record.usedFuelKg !== null && record.usedFuelKg !== 0){
      if (!record.remainingFuelKg || isNaN(record.remainingFuelKg)) {
        error = true;
        errorMessage = "The 'Remaining Fuel' weight is invalid, please enter a valid number";
        field = "remainingFuelKg";
      } else if (record.usedFuelKg < 0) {
        error = true;
        errorMessage = "The 'Used Fuel' weight may not be less than zero";
        field = "usedFuelKg";
      } else if (record.remainingFuelKg < 0) {
        error = true;
        errorMessage = "The 'Remaining Fuel' weight may not be less than zero";
        field = "remainingFuelKg";
      } else if (record.usedFuelKg > record.blockFuelKg) {
        error = true;
        errorMessage = "The 'Used Fuel' weight must not exceed the Block Fuel";
        field = "usedFuelKg";
      }
    }
  } else {
    if (record.openingFuelKg === null || isNaN(parseFloat(record.openingFuelKg))) {
      error = true;
      errorMessage = "The 'Opening Fuel' weight is invalid, please enter a valid number";
      field = "openingFuelKg";
    } else if (record.openingFuelValue === null || isNaN(parseFloat(record.openingFuelValue))) {
      error = true;
      errorMessage = "The 'Opening Fuel' value is invalid, please enter a valid number";
      field = "openingFuelKg";
    } else if (record.openingFuelKg < 0) {
      error = true;
      errorMessage = "The 'Opening Fuel' weight may not be less than zero";
      field = "openingFuelKg";
    } else if (record.openingFuelValue < 0) {
      error = true;
      errorMessage = "The 'Opening Fuel' value may not be less than zero";
      field = "openingFuelValue";
    } else if (record.openingFuelKg > 0 && record.openingFuelValue === 0 ) {
      error = true;
      errorMessage = "The 'Opening Fuel' value may not be zero";
      field = "openingFuelValue";
    } else if (!record.upliftFuelUsg && ((record.openingFuelKg - 5000) > record.blockFuelKg)) {
      error = true;
      errorMessage = "The 'Opening Fuel' weight exceeds the tolerance allowed for the block fuel weight";
      field = "openingFuelKg";
    } else if (record.openingFuelKg === record.blockFuelKg && record.upliftedKg) {
      error = true;
      errorMessage = "The 'Opening Fuel' weight cannot be equal to the block fuel weight if fuel was uplifted";
      field = "openingFuelKg";
    } else if (record.upliftFuelUsg > 0 && (record.upliftFuelUsg < calculatedUpliftFuelUsg * 0.9 || record.upliftFuelUsg > calculatedUpliftFuelUsg * 1.1)) {
      error = true;
      errorMessage = "The 'Uplifted Fuel' in USG is outside the 10% tolerance compared to uplifted fuel weight";
      field = "upliftFuelUsg";
    } else if (isNaN(record.usedFuelKg)) {
      error = true;
      errorMessage = "The 'Used Fuel' weight is invalid, please enter a valid number";
      field = "usedFuelKg";
      //TODO: Need record to have destination to support this check 
    // } else if (record.usedFuelKg <= 0 && record.airportCode !== record.destination) {
    //   error = true;
    //   errorMessage = "The 'Used Fuel' weight must exceed zero";
    //   field = "usedFuelKg";
    } else if (!record.remainingFuelKg || isNaN(record.remainingFuelKg)) {
      error = true;
      errorMessage = "The 'Remaining Fuel' weight is invalid, please enter a valid number";
      field = "remainingFuelKg";
    } else if (record.usedFuelKg < 0) {
      error = true;
      errorMessage = "The 'Used Fuel' weight may not be less than zero";
      field = "usedFuelKg";
    } else if (record.remainingFuelKg < 0) {
      error = true;
      errorMessage = "The 'Remaining Fuel' weight may not be less than zero";
      field = "remainingFuelKg";
    } else if (record.usedFuelKg > record.blockFuelKg) {
      error = true;
      errorMessage = "The 'Used Fuel' weight must not exceed the Block Fuel";
      field = "usedFuelKg";
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );

}

export default AircraftFuelLogDialogValidator;